import { render, staticRenderFns } from "./VannaAiHome.vue?vue&type=template&id=b68ba4b2&scoped=true"
import script from "./VannaAiHome.vue?vue&type=script&lang=js"
export * from "./VannaAiHome.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b68ba4b2",
  null
  
)

export default component.exports